import React from 'react';

export interface AuthContextType {
    authenticated: boolean;
    setAuth: React.Dispatch<React.SetStateAction<boolean>>;
    storedItems: string[];
    setStoredItems: React.Dispatch<React.SetStateAction<string[]>>;
}

const AuthContext = React.createContext<AuthContextType | null>(null);

function AuthProvider({
    dismissBanners = () => {},
    ...props
}: {
    children: JSX.Element;
    dismissBanners: () => void;
}) {
    const [authenticated, setAuth] = React.useState(
        !!window.app.user &&
            !window.app.two_factor_auth_enrollment_in_progress &&
            !window.app?.two_factor_auth_in_progress
    );
    const [storedItems, setStoredItems] = React.useState<string[]>([]);
    React.useEffect(() => {
        if (!authenticated) {
            storedItems.forEach((x) => localStorage.removeItem(x));
            dismissBanners();
            window.postMessage({ method: 'logout' }, window.location.origin);
        }
    }, [authenticated, dismissBanners, storedItems]);
    const methods = {
        authenticated,
        setAuth,
        storedItems,
        setStoredItems,
    };
    return <AuthContext.Provider value={methods} {...props} />;
}

export { AuthContext, AuthProvider };
